import React from 'react';
import styled from 'styled-components';
import { AppLayout } from '../../components/layout';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  line-height: 1.6;
  color: #2d3748;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #1a365d;
  margin-bottom: 24px;
`;

const Section = styled.section`
  margin-bottom: 32px;
`;

const SubTitle = styled.h2`
  font-size: 1.5rem;
  color: #2c5282;
  margin-bottom: 16px;
`;

export const TermsOfService = () => {
  return (
    <AppLayout>
      <Container>
        <Title>Terms of Service</Title>
        <p>Last Updated: January 12, 2026</p>
        
        <Section>
          <SubTitle>1. Acceptance of Terms</SubTitle>
          <p>By accessing or using the ERP Mock platform, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.</p>
        </Section>

        <Section>
          <SubTitle>2. Use License</SubTitle>
          <p>Permission is granted to temporarily access the materials on ERP Mock's platform for personal, non-commercial transitory viewing only.</p>
        </Section>

        <Section>
          <SubTitle>3. Disclaimer</SubTitle>
          <p>The materials on ERP Mock's platform are provided on an 'as is' basis. ERP Mock makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
        </Section>

        <Section>
          <SubTitle>4. Limitations</SubTitle>
          <p>In no event shall ERP Mock or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the platform.</p>
        </Section>

        <Section>
          <SubTitle>5. Governing Law</SubTitle>
          <p>These terms and conditions are governed by and construed in accordance with the laws of the jurisdiction in which ERP Mock operates and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</p>
        </Section>
      </Container>
    </AppLayout>
  );
};
